import { Button } from "@hatch-digital-nl/abs-storybook/legacy";
import { setIsCreateCertificateModalOpen } from "../../modals/CreateCertificateModal/CreateCertificateModalSlice";
import { useAppDispatch } from "../../app/hooks";
import { useIsEstablishmentManager } from "../../common/utils/useIsEstablishmentManager";
import { ApiEnum } from "../../common/enums/ApiEnum";
import { downloadFile } from "../../common/utils/downloadFile";
import { DashboardHeader } from "./components/general/DashboardHeader";
import { DashboardMissingCertificates } from "./components/establishmentManger/DashboardMissingCertificates";
import { DashboardAchievedCertificates } from "./components/employee/DashboardAchievedCertificates";
import { DashboardExpiringSoonCertificates } from "./components/employee/DashboardExpiringSoonCertificates";
import { DashboardScheduledQualifications } from "./components/employee/DashboardScheduledQualifications";
import { DashboardStats } from "./components/establishmentManger/DashboardStats";
import { DashboardEstablishmentInfo } from "./components/general/DashboardEstablishmentInfo";
// Temporarily hidden: Interessante kwalificaties widget
// import { DashboardInterestingQualifications } from "./components/employee/DashboardInterestingQualifications";
import { DashboardEmployeeNotifications } from "./components/employee/DashboardEmployeeNotifications";
import { DashboardEstablishmentManagerNotifications } from "./components/establishmentManger/DashboardEstablishmentManagerNotifications";
import { JSX } from "react";

const DashboardPageContainer = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const isEstablishmentManager = useIsEstablishmentManager();

    return (
        <section className="p-dashboard">
            <DashboardHeader />
            <section className={"p-dashboard__content"}>
                {isEstablishmentManager ? (
                    <>
                        <section className={"p-dashboard__content__left"}>
                            <DashboardEstablishmentManagerNotifications />
                            <DashboardMissingCertificates />
                        </section>
                        <aside className={"p-dashboard__content__right"}>
                            <DashboardStats />
                            <Button
                                variant={"primary"}
                                onClick={() =>
                                    dispatch(
                                        setIsCreateCertificateModalOpen(true),
                                    )
                                }
                            >
                                + Certificaat toevoegen
                            </Button>
                            <Button
                                variant={"tertiary"}
                                onClick={() =>
                                    downloadFile(
                                        ApiEnum.COMPLIANCE_EXPORT,
                                        "ABS - Normen en kwalificaties.xlsx",
                                    )
                                }
                            >
                                Export normen &amp; kwalificaties
                            </Button>
                            <DashboardEstablishmentInfo />
                        </aside>
                    </>
                ) : (
                    <>
                        <section className={"p-dashboard__content__left"}>
                            <DashboardEmployeeNotifications />
                            <DashboardExpiringSoonCertificates />
                            <DashboardAchievedCertificates />
                            <DashboardScheduledQualifications />
                        </section>
                        <aside className={"p-dashboard__content__right"}>
                            <DashboardEstablishmentInfo />
                            <Button
                                variant={"primary"}
                                onClick={() =>
                                    dispatch(
                                        setIsCreateCertificateModalOpen(true),
                                    )
                                }
                            >
                                + Certificaat toevoegen
                            </Button>
                            {/* Temporarily hidden: Interessante kwalificaties widget */}
                            {/* <DashboardInterestingQualifications /> */}
                        </aside>
                    </>
                )}
            </section>
        </section>
    );
};

export default DashboardPageContainer;
